module.exports = __webpack_public_path__ + "img/view.136bfd39.svg";